module.exports = __webpack_public_path__ + "img/success.bd39a938.svg";